import { render } from "./branch.vue?vue&type=template&id=43cd749a&scoped=true"
import script from "./branch.vue?vue&type=script&lang=js"
export * from "./branch.vue?vue&type=script&lang=js"

import "./branch.vue?vue&type=style&index=0&id=43cd749a&lang=scss&scoped=true"
import "./branch.vue?vue&type=style&index=1&id=43cd749a&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43cd749a"]])

export default __exports__